// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3wk5y","title":"ClientInsurance_title__3b0KF","itemText":"ClientInsurance_itemText__oO1NN"};